export default "__VITE_ASSET__BYoZ60ow__"